import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';


async function changeUserPassword(
  password: string,
  auth: Authentication,
  userId: string,
  requirePasswordChange: boolean
): Promise<void> {
  try {
    if (
      ![UserRole.owner, UserRole.admin, UserRole.maintainer].includes(auth.role)
    ) {
      throw new ChangeUserPasswordFailure('Unauthorized', 'unauthorized');
    }

    if(!password || password.length < 8) {
      throw new ChangeUserPasswordFailure('Le mot de passe doit contenir au moins 8 caractères');
    }

    await HttpClient.put('/user/password', { password, userId, require_password_change: requirePasswordChange }, auth.token);
    return;
  } catch (e) {
    console.log('error: ', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new ChangeUserPasswordFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new ChangeUserPasswordFailure("Erreur lors de la mise à jour de l'utilisateur");
    }
  }
}

export class ChangeUserPasswordFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default changeUserPassword;
